import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

export const ThemePreset = definePreset(Aura, {
  primitive: {},
  semantic: {
    colorScheme: {
      light: {
        formField: {
          disabledBackground: '#fbfbfb',
        },
        surface: {
          200: '#d7d7d7',
          400: '#000',
          500: '{grey.500}',
          700: '#000',
        },
        primary: {
          50: '#f5f6f8',
          200: '#e4e7f1',
          300: '#c2c7d7',
          400: '#9fa6b9',
          500: '#5466a6',
          600: '#4f66ab',
          700: '#2d4c9e',
        },
        green: {
          200: '#e5f0e8',
          500: '#609d6d',
          600: '#428f5e',
        },
        red: {
          200: '#f6e4e3',
          500: '#cd5b4e',
          700: '#c74940',
        },
      },
    },
  },
  components: {
    select: {
      colorScheme: {
        light: {
          root: {
            focusBorderColor: '#5466a6',
          },
        },
      },
    },
    toast: {
      content: {
        gap: '1rem',
      },
      text: {
        gap: '0.5rem',
      },
      icon: {
        size: '1.5rem',
      },
      colorScheme: {
        light: {
          success: {
            borderColor: '{green.600}',
            closeButton: {
              focusRing: {
                color: 'transparent',
              },
            },
          },
          error: {
            borderColor: '{red.600}',
            closeButton: {
              focusRing: {
                color: 'transparent',
              },
            },
          },
          warn: {
            borderColor: '{yellow.600}',
            closeButton: {
              focusRing: {
                color: 'transparent',
              },
            },
          },
          info: {
            borderColor: '{blue.600}',
            closeButton: {
              focusRing: {
                color: 'transparent',
              },
            },
          },
        },
      },
    },
    tooltip: {
      colorScheme: {
        light: {
          root: {
            background: '#272931b5',
          },
        },
      },
    },
    tabs: {
      tab: {
        borderWidth: '0 0 3px 0',
        borderColor: 'transparent',
        fontWeight: '500',
        color: '#86878c',
      },
    },
    button: {
      colorScheme: {
        light: {
          root: {
            borderRadius: '0.5rem',
            warn: {
              background: '{yellow.500}',
              borderColor: '{yellow.500}',
              hoverBackground: '{yellow.600}',
              hoverBorderColor: '{yellow.600}',
              activeBackground: '{yellow.600}',
              activeBorderColor: '{yellow.600}',
            },
          },
        },
      },
    },
  },
});

